<template>
  <div>
    <Form :description-title="'Cadastrar novo médico'">
      <CreateButton
        @click="registrarMedico()"
        :icon="PhCloudCheck"
        :label="'Registrar'"
      />
    </Form>
  </div>
</template>

<script setup>
import CreateButton from "@/components/Buttons/Create.vue";
import Form from "../components/FormDoctor.vue";
import {
  cleanAllFormFields,
  setFormFieldsError,
  validateFormField,
} from "@/helpers/formFieldsHandler";
import { showToast as toast } from "@/helpers/UseToasts";
import { dataAso } from "../store";
import { storeApp } from "@/store";
import { onMounted } from "vue";
import * as yup from "@/validator";
import { PhCloudCheck } from "@phosphor-icons/vue";
import AsosService from "../service/asos.service";

const appStore = storeApp.state;
const store = dataAso.state;

const schema = yup.object().shape({
  formDoctor: yup.object().shape({
    nome: yup.string().required('Nome do profissional').label('Médico'),
    especialidade: yup.string().required('Informe a especialidade').label('Cargo'),
    cidade_id: yup.string().required('Informe uma cidade').label('Cidade'),
  })
})

async function registrarMedico () {
  appStore.loading = true

  console.log(store.formDoctor);

  cleanAllFormFields()

  const validate = (await validateFormField(schema, store))

  if (validate && validate.length > 0) {
    console.log(validate);
    setFormFieldsError(validate)
    appStore.loading = false
    return
  }

  await AsosService.registrarMedico(store.formDoctor)
    .then(res => {
      appStore.loading = false

      if (res?.data?.success) {
        toast(
          'Sucesso',
          res?.data?.message,
          'success'
        )
        dataAso.dispatch('resetForm')
      }
    }).catch(err => {
      appStore.loading = false

      if (err?.response?.data?.error && err.response.data.status === 400) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      return toast(
        'Aviso',
        'Algo deu errado ao registrar medico',
        'error'
      )
    })
}

onMounted(async () => {
  appStore.loading = true;
  dataAso.commit("RESET_FORM");
  appStore.loading = false;
});
</script>
